import { DeleteOutlined, PushpinOutlined } from "@ant-design/icons"
import { Button, Divider, Drawer, Form } from "antd"
import { useForm } from "antd/es/form/Form"
import TextArea from "antd/es/input/TextArea"
import axios from "axios"
import { useEffect, useState } from "react"

const Notes = () => {
    const [open, setOpen] = useState(false)
    let [notes, setNotes] = useState([])
    let [render, setRender] = useState(false)

    useEffect(() => {
        axios.get('notes').then(data => {
            setNotes(data.data)
        })
    }, [render])

    let handleDelete = (id) => {
        axios.delete(`notes/${id}`).then(data => {
            setRender(!render)
        })
    }
    let [form] = useForm()
    return (
        <>
            <Button type="primary" onClick={() => { setOpen(true) }} icon={<PushpinOutlined />} />
            <Drawer width={'50%'} title="Eslatmalar" open={open} onClose={() => { setOpen(false) }}>
                <Form form={form}
                    name="basic"
                    initialValues={{ remember: true }}
                    onFinish={(values) => {
                        axios.post('notes', values).then(data => {
                            setRender(!render)
                            form.resetFields()
                        })
                    }}
                    onFinishFailed={() => { }}
                    autoComplete="off"
                    layout='vertical'
                >
                    <Form.Item
                        label="Eslatma"
                        name="note"
                        rules={[{ required: true, message: 'Iltimos matnni kiriting!' }]}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item label={null}>
                        <Button block type="primary" htmlType="submit">
                            Qo'shish
                        </Button>
                    </Form.Item>
                </Form>
                <Divider />
                <h2>Eslatmalar</h2>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px'}}>
                   {notes.map((note, index) => (
                       <div key={index} style={{ padding: '20px', borderRadius: '0 25px 0 0', backgroundColor: '#fff6ec', position: 'relative'}}>
                           <Button onClick={() => handleDelete(note.id)} icon={<DeleteOutlined />} shape="circle" size="small" danger type="primary" style={{position: 'absolute', top: '-5px', right: '-5px'}} />
                           <p>{note.note}</p>
                           
                           <h5 style={{color: '#000', marginTop: '20px'}}>{note.name} : {note.created_at}</h5>
                       </div>
                   ))}
                </div>

            </Drawer>

        </>
    )
}

export default Notes